import { css } from '@emotion/react'
import Markdown from 'markdown-to-jsx'
import { font, mq } from 'plume-ui'

type Props = {
  className?: string
  children?: React.ReactNode
}

export const ExtModulesMarkdown: React.FC<Props> = (props) => {
  return (
    <Markdown
      className={props.className}
      css={css`
        h3 {
          font-size: 20px;
          font-weight: ${font.weight.bold};
          line-height: 1.5;
          letter-spacing: 0.02em;
          margin: 56px 0 0 0;
          ${mq.untilMedium} {
            font-size: 18px;
            margin: 40px 0 0 0;
          }
        }

        h6 {
          font-size: 16px;
          line-height: 2;
          letter-spacing: 0.02em;
          font-weight: ${font.weight.normal};
          margin: 56px 0 0 0;
        }

        p {
          font-size: 16px;
          line-height: 2;
          letter-spacing: 0.02em;
          margin: 24px 0 0 0;
          ${mq.untilMedium} {
            font-size: 15px;
            line-height: 1.75;
            margin: 15px 0 0 0;
          }
        }

        blockquote {
          display: flex;
          justify-content: flex-end;
          margin: 56px 0 0 0;
          text-align: end;
        }

        li {
          font-size: 16px;
          letter-spacing: 0.02em;
          line-height: 2;
          ${mq.untilMedium} {
            font-size: 15px;
            line-height: 1.75;
          }
        }

        ul li {
          list-style-type: disc;
        }
      `}
      options={{}}
    >
      {props.children}
    </Markdown>
  )
}
